import  imageCompression from 'browser-image-compression';


/* const options = { 
    maxSizeMB: number,          // (default: Number.POSITIVE_INFINITY)
    maxWidthOrHeight: number,   // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    onProgress: Function,       // optional, a function takes one progress argument (percentage from 0 to 100) 
    useWebWorker: boolean,      // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
   
    // following options are for advanced user
    maxIteration: number,       // optional, max number of iteration to compress the image (default: 10)
    exifOrientation: number,    // optional, see https://stackoverflow.com/a/32490603/10395024
    fileType: string,           // optional, fileType override
    initialQuality: number      // optional, initial quality value between 0 and 1 (default: 1)
  } */



  export const handleImageUpload = async (event): Promise<File> => {
 
    const imageFile = event.target.files[0];
    // console.log('event.target.files[0]', event.target.files[0]);
    
    const options = {
      maxSizeMB: 0.5,
      // maxWidthOrHeight: 1920,
      useWebWorker: true
    }
    try {
      const compressedFile = await imageCompression(imageFile, options);
      // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
      // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
      // console.log(`Compress file size ${compressedFile } MB`); // smaller than maxSizeMB
      var file = new File([compressedFile], event.target.files[0].name,{type: event.target.files[0]['type']});
     
      return file;
    } catch (error) {
      console.log(error);
      return null;
    }
   
  }

